var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef } from "react";
import { useClickOutside } from "ftl-dashboards-core";
import { FTLDropdownMenu } from "./FTLDropdownMenu";
export const FTLDropdownMenuWithController = (_a) => {
    var { open = false, children, controller, onClick, onClickOutside, disabled } = _a, otherProps = __rest(_a, ["open", "children", "controller", "onClick", "onClickOutside", "disabled"]);
    const containerRef = useRef(null);
    const popperRef = useRef(null);
    useClickOutside(popperRef, (e) => {
        onClickOutside(e);
    });
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: { display: "inline-block" }, ref: containerRef, onClick: (e) => {
                if (!disabled) {
                    onClick(e);
                }
            } }, controller),
        React.createElement(FTLDropdownMenu, Object.assign({ ref: popperRef, open: open, containerRef: containerRef }, otherProps), children)));
};
//# sourceMappingURL=FTLDropdownMenuWithController.js.map